import { FormEvent, useState } from "react";
import { teamEvaluationApi } from "../api/client";
import { TeamEvaluationCreateInput } from "../api/types";

function TeamEvaluation() {
  const [teamId, setTeamId] = useState("team-001");
  const [period, setPeriod] = useState("2025-H1");
  const [collaboration, setCollaboration] = useState(4);
  const [communication, setCommunication] = useState(4);
  const [goalAttainment, setGoalAttainment] = useState(4);
  const [comments, setComments] = useState("Consistent delivery and good alignment.");
  const [status, setStatus] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const payload: TeamEvaluationCreateInput = {
        teamId,
        scores: { collaboration, communication, goalAttainment },
        comments,
        period,
      };
      await teamEvaluationApi.create(payload);
      setStatus("Team evaluation posted successfully to D1 database.");
    } catch (error) {
      setStatus((error as Error).message);
    }
  };

  return (
    <div className="max-w-2xl space-y-4">
      <div>
        <p className="text-sm text-slate-500">Team evaluation</p>
        <h2 className="text-2xl font-semibold text-slate-900">Submit team performance</h2>
      </div>
      <form
        onSubmit={handleSubmit}
        className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4"
      >
        <div className="grid md:grid-cols-2 gap-4">
          <div className="space-y-1">
            <label className="text-sm text-slate-700">Team ID</label>
            <input
              className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring focus:ring-brand-accent"
              value={teamId}
              onChange={(e) => setTeamId(e.target.value)}
              required
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm text-slate-700">Period</label>
            <input
              className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring focus:ring-brand-accent"
              value={period}
              onChange={(e) => setPeriod(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          <div className="space-y-1">
            <label className="text-sm text-slate-700">Collaboration</label>
            <input
              type="number"
              min={1}
              max={5}
              className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring focus:ring-brand-accent"
              value={collaboration}
              onChange={(e) => setCollaboration(Number.parseInt(e.target.value, 10) || 0)}
              required
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm text-slate-700">Communication</label>
            <input
              type="number"
              min={1}
              max={5}
              className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring focus:ring-brand-accent"
              value={communication}
              onChange={(e) => setCommunication(Number.parseInt(e.target.value, 10) || 0)}
              required
            />
          </div>
          <div className="space-y-1">
            <label className="text-sm text-slate-700">Goal attainment</label>
            <input
              type="number"
              min={1}
              max={5}
              className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring focus:ring-brand-accent"
              value={goalAttainment}
              onChange={(e) => setGoalAttainment(Number.parseInt(e.target.value, 10) || 0)}
              required
            />
          </div>
        </div>

        <div className="space-y-1">
          <label className="text-sm text-slate-700">Comments</label>
          <textarea
            className="w-full rounded-md border border-slate-300 px-3 py-2 focus:outline-none focus:ring focus:ring-brand-accent"
            rows={4}
            value={comments}
            onChange={(e) => setComments(e.target.value)}
          />
        </div>

        <button
          type="submit"
          className="px-4 py-2 rounded-md bg-brand-primary text-white font-semibold hover:bg-brand-muted transition-colors"
        >
          Submit team evaluation
        </button>
        {status && <p className="text-sm text-slate-600">{status}</p>}
      </form>
    </div>
  );
}

export default TeamEvaluation;
